import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import _ from 'lodash';
import { DropdownButton } from 'react-bootstrap';

import Header from '../../../components/Header/Header';
import FormattedMessage from '../../../components/FormattedMessage';
import { updateStepData } from '../SubscribeActions';
import { Plans, BillingInfo, PaymentMethod, Confirmation, Dashboards } from '../components';
import { PAGES, trackPageView } from '../../../util/mixpanel';

import createDashboardIcon from '../../../assets/images/createDashboard-icon.svg';

import './../Subscribe.scss';

class Subscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };
  }

  componentWillUnmount() {
    this.props.updateStepData({});
  }

  componentDidMount() {
    trackPageView(PAGES.SUBSCRIBE);
  }

  render() {
    const { step } = this.state;
    const { outside, user, app } = this.props;

    let buttons = [
      <DropdownButton
        key="1"
        id="createdashboards-dropdown"
        size='sm'
        variant='secondary'
        title={<img src={createDashboardIcon} alt="" />}
      >
        <li>
          <Link to="/create" className="btn">
            Create dashboard
            <span className="help-text">
              Select <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" /> and drag &amp; drop your{' '}
              <FormattedMessage id={`${app}.list`} plural="true" /> into the Kanban process flow.
            </span>
          </Link>
        </li>
      </DropdownButton>,
    ];

    if (outside) {
      buttons = [];
    }

    return (
      <div>
        <Helmet>
          <title>{pageTitle('Billing')}</title>
        </Helmet>
        <Header showHome={true} buttons={buttons} />
        <div className='subscribe_content'>
          <div className='indicator'>
            <div className={`item ${step > 2 && 'passed'} ${step < 3 && 'active'}`}>
              { step === 2 ? 
                <React.Fragment><span className='number'>1</span> Remove dashboards</React.Fragment>
                : <React.Fragment><span className='number'>1</span> Select plan</React.Fragment>
              }
            </div>
            <div className={`item ${step > 3 && 'passed'} ${step === 3 && 'active'}`}><span className='number'>2</span>Add billing details</div>
            <div className={`item ${step > 4 && 'passed'} ${step === 4 && 'active'}`}><span className='number'>3</span>Confirm subscription</div>
            <div className={`item ${step > 5 && 'passed'} ${step === 5 && 'active'}`}><span className='number'>4</span>Add payment method</div>
          </div>
          {step === 1 && <Plans onNext={(step) => this.setState({ step })} />}
          {step === 2 && <Dashboards onNext={() => this.setState({ step: 3 })} onBack={() => this.setState({ step: 1 })}/>}
          {step === 3 && (
            <BillingInfo onNext={() => this.setState({ step: 4 })} onBack={() => this.setState({ step: 1 })} />
          )}
          {step === 4 && (
            <Confirmation onNext={() => this.setState({ step: 5 }) } onBack={() => this.setState({ step: 3 })} />
          )}
          {step === 5 && <PaymentMethod onBack={() => this.setState({ step: 4 })} />}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateStepData: (model) => dispatch(updateStepData(model)),
  };
};

const mapStateToProps = (state) => {
  return {
    app: state.app.app,
    outside: state.app.outside,
    reqSent: state.subscription.sent,
    user: state.auth.user,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscribe));
